import Multiple from '../views/multiple/index.vue'
import Pdf from '../views/pdf/index.vue'
import Join from '../views/join/index.vue'

export default [{
  path: '/multiple',
  name: 'multiple',
  component: Multiple
}, {
  path: '/pdf',
  name: 'pdf',
  component: Pdf
}, {
  path: '/join',
  name: 'join',
  component: Join
}]
